import { createSafeContext } from '@/util';

import type { VNotificationContextValue } from './type';

export const VNotificationContext =
  createSafeContext<VNotificationContextValue>(null, 'VNotificationContext');
